import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16">
      <SEO
        title="About Competition Checker"
        description="Competition Checker is an independent UK prize competition transparency and odds comparison site."
        path="/about"
      />
      <div className="overline text-[var(--cc-gold)] mb-2">About</div>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold">
        Independent UK prize competition transparency
      </h1>
      <div className="mt-8 space-y-6 text-[var(--cc-text-muted)] leading-relaxed">
        <p>
          Competition Checker helps people compare UK prize competitions before
          they enter. We focus on transparent information: ticket price, maximum
          entries where trusted, draw date, operator signals, prize category and
          whether key data is missing or uncertain.
        </p>
        <p>
          We do not operate prize draws, sell tickets, process entries, or
          guarantee outcomes. Always check the operator's official competition
          page and terms before entering.
        </p>
        <section>
          <h2 className="font-display text-xl font-semibold text-white mb-2">
            Independent information service
          </h2>
          <p>
            Our role is to analyse publicly available competition information
            for UK consumers. Competition entries, payments, prize awards and
            official free-entry routes remain the responsibility of the
            operator.
          </p>
        </section>
        <p>
          Competition Checker is operated by QUOD-Tech Ltd. For general
          enquiries, contact{" "}
          <a className="text-[var(--cc-gold)] hover:underline" href="mailto:info@competitionchecker.com">
            info@competitionchecker.com
          </a>
          . For business or partnership enquiries, contact{" "}
          <a className="text-[var(--cc-gold)] hover:underline" href="mailto:info@quod-tech.com">
            info@quod-tech.com
          </a>
          .
        </p>
        <p>
          Competition Checker may earn commission from some outbound links where
          an operator has an approved affiliate or partner arrangement with us.
          Affiliate links are clearly labelled where used. Affiliate
          relationships do not influence scoring, ranking, odds calculations,
          operator trust notes, or whether a competition is shown.
        </p>
        <div className="pt-2 flex flex-wrap gap-3">
          <Link className="text-[var(--cc-gold)] hover:underline" to="/how-we-score">
            Read how we score
          </Link>
          <Link className="text-[var(--cc-gold)] hover:underline" to="/responsible-participation">
            Responsible participation
          </Link>
        </div>
      </div>
    </div>
  );
}
